import { SidePanelStatus } from "@nova/component-side-panel-tab-container"
import {
    getSatelliteJobErrorMessage,
    JobStatusType,
    JobTypes,
    SATELLITE_JOB_TYPE_BY_SENSOR_TYPE,
    SatelliteSensorType,
} from "@nova/constants"
import { dateFromNumber } from "@nova/serializer/src/client/util"
import { selectSatelliteFlightById } from "features/entity-caching/flights/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { StatusAndProgressData } from "../generics/GenericLayerListItemProgress"
import { useJobProgress } from "../useJobProgress"
import { estimateSatelliteProcessingSeconds } from "plugins/Satellite/estimateProcessingDuration"

export function useSatelliteStatusAndProgress(id: string): StatusAndProgressData {
    const entity = useAppSelector(selectSatelliteFlightById(id))
    const progress = useJobProgress({
        job: entity.job,
        type:
            SATELLITE_JOB_TYPE_BY_SENSOR_TYPE[entity.sensorType as SatelliteSensorType] ??
            JobTypes.Satellite,
        totalDurationSeconds: estimateSatelliteProcessingSeconds(
            entity.region,
            entity.sensorType as SatelliteSensorType
        ),
    })
    const createdAtDate = entity.job ? dateFromNumber(entity.job.createdAt) : undefined

    switch (entity.job?.status) {
        case JobStatusType.QUEUED:
        case JobStatusType.STARTED:
            return {
                status: SidePanelStatus.loading,
                progress,
                createdAtDate,
            }
        case JobStatusType.COMPLETED:
            return {
                status: undefined,
            }
        case JobStatusType.FAILED:
            return {
                status: SidePanelStatus.failed,
                message: getSatelliteJobErrorMessage(entity.job.error),
            }
        default:
            return {
                status: undefined,
            }
    }
}
